import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { ConfigProvider } from 'antd';
import classNames from 'classnames';
import colors from '~/constants/colors';
import Header from '~/layouts/Header';
import theme from '~/constants/theme';
import handWithApp from '~/img/womenWithPos.1028ae63.jpg';
import manWithApp from '~/img/manWithApp.png';
import { Button, Scrollbars } from '~/components';
import { DirectionProp } from '~/types/Direction';
import { useDirection } from '~/hooks/i18nHooks';
import handshake from '~/img/handshake.jpg';
import {
  LayoutBackgroundImage,
  useAppContext,
} from '../../pages/ksa/dataValidation/components/Context';

export const HEADER_HEIGHT = 80;

interface IProps {
  children: React.ReactNode;
  image?: string;
}

const CompanyInfoLayout: FC<IProps> = (props) => {
  const { image, children } = props;
  const dir = useDirection();

  const { layoutBackgroundImage } = useAppContext();

  return (
    <ConfigProvider componentSize={componentSize} direction={dir}>
      <Header />
      <Scrollbars style={getScrollbarsStyles()}>
        <CenterContainer>
          <Container
            className={classNames('RootLayout', { rtl: dir === 'rtl' })}
            layoutBackgroundImage={image || layoutBackgroundImage}
            dir={dir}
          >
            <div className="RootLayout-Body">
              <div className="RootLayout-FormContainer">{children}</div>
            </div>
          </Container>
        </CenterContainer>
      </Scrollbars>
    </ConfigProvider>
  );
};

const componentSize = 'large';

const getScrollbarsStyles = () => ({
  minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
});

type UIProps = { layoutBackgroundImage: LayoutBackgroundImage | string } & DirectionProp;

const Container = styled.div<UIProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 16px 16px 16px;
  max-width: 1472px;
  background-color: ${colors.layoutBodyBackground};
  min-height: calc(100vh - ${HEADER_HEIGHT}px + 16px);
  h1 {
    margin-top: 0;
    margin-bottom: 32px;
  }
  @media (max-width: ${theme.breakpoints.sm}px) {
    padding: 0 12px 12px 12px;
    min-height: calc(100vh - ${HEADER_HEIGHT}px + 12px);
  }
  .RootLayout-Body::after {
    content: '';
    width: calc(50% + 8px);
    margin-left: -8px;
    display: flex;
    background-color: ${colors.layoutBodyBackground};

    ${({ dir }) =>
    dir === 'rtl'
      ? css`
            transform: scaleX(-1);
          `
      : undefined}
    ${({ layoutBackgroundImage }) => {
    if (layoutBackgroundImage === LayoutBackgroundImage.HAND_WITH_APP) {
      return css`
          background-image: url(${handWithApp});
          background-repeat: no-repeat;
        `;
    }
    if (layoutBackgroundImage === LayoutBackgroundImage.MAN_WITH_APP) {
      return css`
          background-image: url(${manWithApp});
          background-repeat: no-repeat;
        `;
    }
    if (layoutBackgroundImage === LayoutBackgroundImage.SUCCSESS) {
      return css`
          background-image: url(${handshake});
          background-repeat: no-repeat;
        `;
    }
    return undefined;
  }}
    background-position: right -1px top;
    background-size: auto 100%;
    @media (max-width: ${theme.breakpoints.md}px) {
      content: none;
      border-radius: ${theme.borderRadiusSm}px;
      background-image: none;
    }
  }
  .RootLayout-Body {
    display: flex;
    height: calc(100% - 16px);
    background-color: ${colors.layoutBodyBackground};
    border-radius: ${theme.borderRadiusBase}px;
    overflow: hidden;

    .RootLayout-FormContainer {
      width: 50%;
      min-width: ${theme.formInputMaxWidth}px;
      background-color: ${colors.componentBackground};
      padding: 80px 40px;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-self: stretch;
      z-index: 100;

      min-height: 490px;

      .ant-form-item,
      .ant-btn-block {
        max-width: ${theme.formInputMaxWidth}px;
      }
      @media (max-width: ${theme.breakpoints.md}px) {
        width: 100%;
        min-width: auto;
        padding: 80px 40px;
      }
      @media (max-width: ${theme.breakpoints.sm}px) {
        width: 100%;
        min-width: auto;
        padding: 64px 24px;
      }
      @media (max-width: ${theme.breakpoints.xs}px) {
        width: 100%;
        min-width: auto;
        padding: 32px 16px;
      }
    }
  }
`;

const CenterContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  background-color: ${colors.layoutBodyBackground};
`;

export const ConfirmButton = styled(Button) <any>`
  margin-top: 8px;
  height: 56px;
  border-radius: 8px;
  width: 100%;
  font-weight: 500;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;

  &[disabled], &[disabled]:hover, &[disabled]:focus, &[disabled]:active {
    background-color: #F5F9FC !important;
    border: 1px solid #DADADA !important;
    color: rgba(0, 0, 0, 0.25) !important;
  }

  //max-width: ${theme.formInputMaxWidth / 2}px;
  @media (max-width: ${theme.breakpoints.md}px) {
    width: 100%;
    max-width: unset;    
  }
`;

export default CompanyInfoLayout;
